import type { Prototype } from "../prototype-types";

export const johnAdesidaPrototypes: Prototype[] = [
  {
    id: "ja-signup-platform-m-2",
    name: "Signup System Redesign",
    path: "/ja/signup-platform-m-2",
    description:
      "Interactive product case for Milestone 2 of the Signup System Redesign: any team can own its flow without touching shared code.",
    owner: "John Adesida",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-17",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/05ef2314cf65acf8cff391539db8c14493e1d4c10936e224884740b0ff00d82e.png",
    creationTool: "claude-code",
  },
  {
    id: "ja-posthog-cost-calculator",
    name: "PostHog Override Cost Calculator",
    path: "/ja/posthog-cost-calculator",
    description:
      "Estimate the monthly cost of a PostHog recording override or new event, with per-input guidance and sample Snowflake queries against our PETE events table.",
    owner: "John Adesida",
    createdAt: "2026-06-17",
    lastUpdated: "2026-06-17",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/1b80e46d0fefcb69c4213d5d3e7f19aa26d96dba7a10ddeaddee9737dd0954cd.png",
    creationTool: "claude-code",
  },
  {
    id: "ja-scc-non-bm-mockup",
    name: "SCC for Non-B&M — Credit-Details Flow",
    path: "/ja/scc-non-bm-mockup",
    description:
      "Today vs Proposed walkthrough of the SCC credit-details step for non-B&M signup, addressing the onboarding drop in SCC_HIGHER_TERMS_FOR_NON_OWF_NON_BM_RETAILERS_XP_260414.",
    owner: "John Adesida",
    createdAt: "2026-07-02",
    lastUpdated: "2026-07-02",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    creationTool: "claude-code",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/3fd1499365952425fc0016dfc22c430f956adb131b852af197298ca47a555996.png",
  },
  {
    id: "ja-social-profile-signup",
    name: "Social Profile Signup",
    path: "/ja/social-profile-signup",
    description:
      "Interactive playground for optional social profiles and a combined website + social signup step, with layout directions, mocked reachability, and completion personas.",
    owner: "John Adesida",
    createdAt: "2026-07-20",
    lastUpdated: "2026-08-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Merge website and social media signup steps",
    thumbnail:
      "https://cdn.prerelease.faire.dev/fastly/ba979723162bf6cc5bde929b048c93b964c25df18698ed41555110518a9229df.png",
  },
  {
    id: "ja-magic-retailer-signup",
    name: "Magic Retailer Signup",
    path: "/ja/magic-retailer-signup",
    description:
      "Confirm card plus skip/poll lookup. Team share demo of the Magic spine.",
    owner: "John Adesida",
    createdAt: "2026-08-14",
    lastUpdated: "2026-08-17",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail:
      "https://cdn.faire.com/fastly/3639dc18abc4024562e540b6076fef5179c6a5bb93fcfa5b73009a8caa522b0d.png",
  },
  {
    id: "ja-signup-helper-learnings",
    name: "Signup Helper Learnings",
    path: "/ja/signup-helper-learnings",
    description:
      "Team walkthrough of Signup Flow Assistant chats by step. Baked FLARE snapshot, not live warehouse.",
    owner: "John Adesida",
    createdAt: "2026-08-19",
    lastUpdated: "2026-08-21",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Signup Flow Assistant",
    thumbnail:
      "https://cdn.faire.com/fastly/4ae0e13be940a4743fbbb4fb524ac2acc5e023255d80e95bef61cfbcb50830e5.png",
  },
  {
    id: "ja-signup-inline-field-help",
    name: "Signup Inline Field Help",
    path: "/ja/signup-inline-field-help",
    description:
      "Switchable entry-point and escalation patterns for inline signup help on Website, Store type, and Annual sales, with chat handoff quoting inline context.",
    owner: "John Adesida",
    createdAt: "2026-09-23",
    lastUpdated: "2026-09-23",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "mobile",
    creationTool: "cursor",
    project: "Signup Flow Assistant",
    thumbnail:
      "https://cdn.faire.com/fastly/4ae0e13be940a4743fbbb4fb524ac2acc5e023255d80e95bef61cfbcb50830e5.png",
  },
  {
    id: "ja-signup-helper-ideas",
    name: "Signup Helper Ideas",
    path: "/ja/signup-helper-ideas",
    description:
      "Control vs Proposed mocks of Website, Store type, Annual sales, and Legal business name from Signup Helper idea hypotheses. https://app.notion.com/p/3c82efb5c25a80448950ff9f8bb204bb",
    owner: "John Adesida",
    createdAt: "2026-08-27",
    lastUpdated: "2026-08-27",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Signup Flow Assistant",
    thumbnail:
      "https://cdn.faire.com/fastly/4ae0e13be940a4743fbbb4fb524ac2acc5e023255d80e95bef61cfbcb50830e5.png",
  },
  {
    id: "ja-test-my-feature",
    name: "Test My Feature",
    path: "/ja/test-my-feature",
    description:
      "Single UX for agentic feature verification: runs hub, intake and plan approval, run report with surface x scenario matrix and coverage gaps, evidence drilldown with agent trace, Slack notification mock.",
    owner: "John Adesida",
    createdAt: "2026-09-03",
    lastUpdated: "2026-09-03",
    surfaceArea: "Other",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    thumbnail: "/images/thumbnails/ja-test-my-feature.png",
  },
  {
    id: "ja-mobile-web-nav-targets",
    name: "Mobile Web Nav + Tap Targets",
    path: "/ja/mobile-web-nav-targets",
    description:
      "Before/after playground for split side nav and larger tap targets on mobile web.",
    owner: "John Adesida",
    createdAt: "2026-09-18",
    lastUpdated: "2026-09-18",
    surfaceArea: "Retailer",
    category: "experimental",
    status: "in-progress",
    platform: "web",
    creationTool: "cursor",
    project: "Mobile Web Improvements",
    thumbnail: "/images/thumbnails/ja-mobile-web-nav-targets.png",
  },
];
